/** RPC-backed queue summary; it deliberately owns no local retry timer or queue. The conflict-review action (open-conflicts button) is intentionally absent—no resolution path is implemented yet (see #1477); it will return when one lands. */
export class NodeSyncCenterElement extends HTMLElement {
    #client;
    #records = [];
    #unsubscribe;
    connectedCallback() { this.render(); this.#subscribe(); }
    disconnectedCallback() { this.#unsubscribe?.(); this.#unsubscribe = undefined; }
    set client(value) {
        this.#client = value;
        this.#unsubscribe?.();
        this.#unsubscribe = undefined;
        if (this.isConnected)
            this.#subscribe();
    }
    get client() { return this.#client; }
    render() {
        const pending = this.#records.filter((record) => record.state === "pending" || record.state === "replaying").length;
        const conflicts = this.#records.filter((record) => record.state === "conflict").length;
        this.innerHTML = `
      <section class="node-sync-center" aria-label="Sync center">
        <div><strong>Sync center</strong><span aria-live="polite">${pending} pending · ${conflicts} conflicts</span></div>
      </section>`;
    }
    #subscribe() {
        if (!this.#client || this.#unsubscribe !== undefined)
            return;
        this.#unsubscribe = this.#client.liveQuery("sync.outbox-status.v1", {}, (diff) => {
            const records = new Map(this.#records.map((record) => [record.id, record]));
            for (const record of diff.deleted)
                records.delete(record.id);
            for (const record of [...diff.added, ...diff.updated])
                records.set(record.id, record);
            this.#records = [...records.values()].sort((left, right) => left.createdAt.localeCompare(right.createdAt));
            this.render();
        });
    }
}
//# sourceMappingURL=sync-center.js.map